import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/free-mode";
import "swiper/css/navigation";

const OurClients = () => {
  const clientCategories = [
    {
      title: "Government Technology Universities",
      logos: [
        "https://upload.wikimedia.org/wikipedia/en/thumb/9/9e/University_of_Hyderabad_Logo.png/250px-University_of_Hyderabad_Logo.png", // Andhra Uni (Official)
        "https://www.andhrauniversity.edu.in/img/logo.png", // Andhra Uni (Official)
        "https://png.pngtree.com/png-vector/20221207/ourmid/pngtree-university-logo-png-image_6513311.png", // Andhra Uni (Official)
      ],
    },
    {
      title: "Medical Universities",
      logos: [
        "https://website.aiimsraipur.edu.in/web_image/lg1.png", // AIIMS (Wikimedia)
        "//upload.wikimedia.org/wikipedia/en/thumb/9/93/King_George%27s_Medical_University_Logo.png/250px-King_George%27s_Medical_University_Logo.png", // KG Medical Uni (Official)
        "https://upload.wikimedia.org/wikipedia/commons/7/75/SMC_Logo.png", // JIPMER (Official)
      ],
    },
    {
      title: "General Universities",
      logos: [
        "assets/images/1.png",
        "assets/images/11.png",
        "assets/images/111.png",
      ],
    },
    {
      title: "Government Education Boards",
      logos: [
        "https://upload.wikimedia.org/wikipedia/en/thumb/5/5c/Central_Board_of_Secondary_Education_Logo.svg/300px-Central_Board_of_Secondary_Education_Logo.svg.png", // CBSE (Wikimedia)
        "https://upload.wikimedia.org/wikipedia/en/thumb/7/7b/Board_of_Intermediate_Education%2C_Andhra_Pradesh_Logo.png/300px-Board_of_Intermediate_Education%2C_Andhra_Pradesh_Logo.png", // BIEAP (Wikimedia)
        "https://mahahsscboard.in/wp-content/uploads/2022/02/msbshse-logo.png", // Maharashtra Board (Official)
      ],
    },
  ];

  const allLogos = clientCategories.flatMap((category) => category.logos);

  const colors = {
    primary: "#1565C0", // Dark Blue
    secondary: "#0D47A1", // Navy Blue
    light: "#00001a", // Dark Navy background
    accent: "#4CAF50", // Green accent
    dark: "#0A1E3C", // Darker Navy
    textLight: "#E3F2FD", // Light text
    textDark: "#0D47A1", // Dark text
  };

  return (
    <section
      className="py-5  mt-60 position-relative overflow-hidden"
      style={{ backgroundColor: colors.light }}
    >
      {/* Decorative Shapes */}
      <img
        src="/assets/images/shape/offer-shadow-shape.png"
        alt="shadow shape"
        className="position-absolute start-0 top-0 opacity-25"
        style={{ width: "150px" }}
      />
      <img
        src="/assets/images/shape/offer-bg-shape-left.png"
        alt="left shape"
        className="position-absolute bottom-0 start-0 opacity-25"
        style={{ width: "120px" }}
      />
      <img
        src="/assets/images/shape/offer-bg-shape-right.png"
        alt="right shape"
        className="position-absolute bottom-0 end-0 opacity-25"
        style={{ width: "120px" }}
      />

      <div className="container">
        <div className="text-center mb-5">
          <h2 className="text-white fw-bold mb-3" style={{ fontSize: "2rem" }}>
            Our clientele
          </h2>
          <div
            className="mx-auto mb-4"
            style={{
              height: "4px",
              width: "80px",
              background: `linear-gradient(90deg, ${colors.primary}, ${colors.accent})`,
              borderRadius: "2px",
            }}
          ></div>
          <p
            className="text-white-50 mb-0 mx-auto"
            style={{ maxWidth: "700px" }}
          >
            We work with leading Government Technology Universities, Medical
            Universities, General Universities, Government Education Boards, and
            Autonomous Institutions across India, along with our technology and
            integration partners.
          </p>
        </div>

        {/* Logo Carousel */}
        <div className="mb-5">
          <Swiper
            modules={[Autoplay, FreeMode]}
            slidesPerView={"auto"}
            spaceBetween={30}
            loop={true}
            freeMode={true}
            freeModeMomentum={false} // prevents bounce
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={5000} // higher = slower, lower = faster
            grabCursor={false}
            allowTouchMove={false}
            cssMode={false}
            className="swiper-wrapper"
          >
            {allLogos.map((src, index) => (
              <SwiperSlide
                key={index}
                className="swiper-slide"
                style={{
                  width: "173.2px",
                  marginRight: "30px",
                }}
              >
                <div
                  className="p-2 h-100 d-flex align-items-center"
                  style={{
                    backgroundColor: colors.dark,
                  }}
                >
                  <img
                    // src={src}
                    src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxdAOY_-vITFVI-ej84s2U_ErxhOly-z3y_Q&s'
                    alt={`Partner logo ${index + 1}`}
                    className="img-fluid rounded mx-auto"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "80px",
                    }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Client Categories */}
        {/* <div className="row mt-4 ">
          {clientCategories.map((category, index) => (
            <div key={index} className="col-lg-4 mb-4 col-md-6 ">
              <div
                className="rounded p-4 h-100"
                style={{
                  backgroundColor: colors.dark,
                  // border: `1px solid ${colors.primary}`,
                }}
              >
                <h4 className="text-white mb-3">{category.title}</h4>
                <div className="d-flex flex-wrap gap-3 flex-row ">
                  {category.logos.map((logo, logoIndex) => (
                    <div
                      key={logoIndex}
                      className="rounded p-2 d-flex align-items-center justify-content-center"
                      style={{
                        width: "80px",
                        height: "80px",
                        backgroundColor: colors.light,
                        // border: `1px solid ${colors.accent}`,
                      }}
                    >
                      <img
                        src={logo}
                        alt={`${category.title} logo ${logoIndex + 1}`}
                        className="img-fluid"
                        style={{
                          objectFit: "contain",
                          maxHeight: "100%",
                          maxWidth: "100%",
                          // filter: "brightness(0) invert(1)",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
};

export default OurClients;
